import {
  makeStyles, Theme, Grid, TableContainer,
  Table, TableHead, TableRow, TableBody, TableCell, IconButton, Collapse, Box
} from "@material-ui/core";
import { AIDocType } from "@roc/feature-documents";
import { DocReviewBaseStore } from '../store/docReviewBaseStore';
import { observer } from "mobx-react";

const useStyles = makeStyles((theme: Theme) => ({
  section: {
    padding: '20px 20px 0 20px'
  },
  reviewSectionContainer: {
    paddingBottom: '20px'
  },
  tableContainer: {
    border: '1px #e0e0e0 solid',
    backgroundColor: '#FFF',
    width: '100%',
    boxSizing: 'border-box',
  },
  table: {
    margin: 0,
    padding: 0,
    '& td': {
      padding: '5px 0',
    },
    '& th:first-child, td[rowSpan], $addNewItemRow td, td:first-child': {
      paddingLeft: theme.spacing(2),
      paddingRight: '3px',
    },
    '& table tr:last-child td, & table td[rowSpan]': {
      borderBottom: 'none',
    },
    '& input': {
      padding: '12px',
      fontSize: '0.875rem'
    }
  },
  sectionTitle: {
    fontSize: '20px',
  },
  noBorderCell: {
    border: 0,
  },
  sectionNameCell: {
    width: '30%',
  },
  itemCell: {
    width: '15%',
  },
  commentCell: {
    width: '55%',
  },
  cell: {
    padding: '12px !important',
    paddingRight: '24px !important',
  },
  header: {
    fontWeight: 'bold',
  },
}));

export const sendForRevisionColumns = [
  { name: 'Item', mapping: 'itemDisplayName' },
  { name: 'Reviewer Comment', mapping: 'reviewerCommentRevision' }
];

export const SendForRevisionTable = observer(({ store }
  : { store: DocReviewBaseStore }) => {
  const classes = useStyles();

  const getClassNameByColumn = (mapping) => {
    switch (mapping) {
      case 'itemDisplayName':
        return classes.itemCell;
      case 'reviewerCommentRevision':
        return classes.commentCell;
    }
  }

  return (
    <Grid container className={classes.reviewSectionContainer}>
      <Grid container item xs={12} style={{ maxHeight: '55vh', overflow: 'auto' }}>
        {!store.sectionsMarkedForRevision.length ? (
          <TableRow>
            <TableCell colSpan={10} className={classes.noBorderCell}>
              <Box>
                No items have been selected for revision
              </Box>
            </TableCell>
          </TableRow>
        ) :
          <Grid item xs={12} className={classes.section}>
            <TableContainer className={classes.tableContainer}>
              <Table className={classes.table} size='small' stickyHeader>
                {store.sectionsMarkedForRevision.map(section => (
                  <>
                    <TableHead key={`${section.sectionName}-head-columns`}>
                      <TableRow key={`${section.sectionName}-head-columns-row`}>
                        <TableCell key={section.sectionName} className={`${classes.sectionNameCell} ${classes.header} ${classes.cell}`}>{section.sectionName}</TableCell>
                        {sendForRevisionColumns?.map((column, index) => (
                          <TableCell key={`${section.sectionName}-${column.name}`} className={`${getClassNameByColumn(column.mapping)} ${classes.header} ${classes.cell}`}>{column.name}</TableCell>
                        ))}
                      </TableRow>
                    </TableHead>
                    <TableBody key={`${section.sectionName}-body-rows`}>
                      {section.items.filter(item => item.sendForRevision).map((item: any, index: number) => (
                        <TableRow key={`${section.sectionName}-${index}-content-row`}>
                          <TableCell className={`${classes.sectionNameCell} ${classes.cell}`} />
                          <TableCell key={`${section.sectionName}-${index}-${item.data}`}
                            className={`${classes.itemCell} ${classes.cell}`}>{item.itemDisplayName}</TableCell>
                          <TableCell key={`${section.sectionName}-${index}-${item.reviewerComment}`}
                            className={`${classes.commentCell} ${classes.cell}`}>{item.reviewerComment}</TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  </>
                ))}
              </Table>
            </TableContainer>
          </Grid>}
      </Grid>
    </Grid>);
});